module.exports = __webpack_public_path__ + "img/01.6759716a.jpg";